import {
  Box,
  Button,
  Dialog,
  DialogProps,
  Divider,
  FormControl,
  FormControlLabel,
  MenuItem,
  OutlinedInput,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Theme,
  useTheme,
} from "@mui/material";
import React, { ChangeEvent, useCallback } from "react";
import Radio from "@mui/material/Radio";
// import styles from "@/styles/components/filterModal.module.scss";
import assest from "../../../json/assest";
import styles from "../../../styles/components/MemberPartnerDashboard/member-partner-filter.module.scss";
import dropdownStyles from "../../../lib/functions/dropwdownstyles";
import {
  countryData,
  getMonthQueryRange,
  sampleMonthsValueArray,
  sampleYearList,
} from "../../../lib/functions/utils.lib";
import { useEffect } from "react";
// import assest from "@/json/assest";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    sx: dropdownStyles(134),
  },
};

const names = ["Ten", "Twenty", "Thirty"];

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}
// export type FilterModalProps = DialogProps & {
//     hideBottom?: boolean;
//     modalFields:
//         | {
//               has_note: string;
//               unreachable_submitter: string;
//               people_appearing: string;
//               person_who_filmed: string;
//               submit_other_website: string;
//               aggrement_with_another_company: string;
//           }
//         | any;
//     handleFilterParamChange: (event: ChangeEvent<HTMLInputElement>) => void;
//     resetFilterparams: () => void;
//     handleFilterSelect: () => void;
// };

const MyVideosApprovedFilterModal = (props) => {
  const {
    hideBottom,
    onClose,
    setDateFilter,
    currentFilterParams,
    videoCountry,
    setVideoCountry,
    dateFilter,
    handleDateFilter,
    handleFilter,
    ...rest
  } = props;
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);
  //console.warn(hideBottom,"hideBottom");

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      value
    );
  };

  const handleClose = useCallback(
    (e, reason) => {
      onClose?.(e, reason || "backdropClick");
    },
    [onClose]
  );

  // handel date filter
  const [month, setMonth] = React.useState("");

  const handleChangeMonth = (event) => {
    setMonth(event.target.value);
  };

  const [year, setYear] = React.useState("");

  const handleChangeYear = (event) => {
    setYear(event.target.value);
  };
  const [location, setLocation] = React.useState(
    videoCountry ? videoCountry : ""
  );
  const handleChangeLocation = (event) => {
    setLocation(event.target.value);
  };

  const [filterParams, setFilterParams] = React.useState({
    unreachable_submitter: "",
    open_messages: "",
    unreachable_submitter: "",
    duplicate: "",
    people_appearing: "",
    person_who_filmed: "",
    submit_other_website: "",
    aggrement_with_another_company: "",
    filter_active: false,
  });
  const resetFilter = () => {
    setFilterParams({
      unreachable_submitter: "",
      open_messages: "",
      duplicate: "",
      people_appearing: "",
      person_who_filmed: "",
      submit_other_website: "",
      aggrement_with_another_company: "",
      filter_active: false,
    });
    setMonth("");
    setYear("");
    setLocation("");
  };

  const handleResetSingleField = (name) => {
    setFilterParams((prev) => {
      return { ...prev, [name]: "" };
    });
  };

  const handleFilterParamChange = (event) => {
    const { name, value } = event.target;
    setFilterParams((prev) => {
      return {
        ...prev,
        [name]: value,
        filter_active: true,
      };
    });
  };

  const submitFilter = () => {
    const dates = getMonthQueryRange(month, year, "obj");
    handleFilter({
      ...filterParams,
      when_filmed: dates?.from_date,
      country: location,
    });

    handleClose();
  };
  useEffect(() => {
    if (currentFilterParams === null) {
      resetFilter();
    }
  }, [currentFilterParams]);
  // handel date filter

  return (
    <Dialog className={styles.filterModal} {...rest} onClose={handleClose}>
      <Box className={styles.filterModalWrapper}>
        <Box className={styles.filterModalHeader}>
          <h4>Filter</h4>
          <Button onClick={resetFilter}>
            <img src={assest.resetIcon} width={9} height={9} alt="" />
            <p>Clear</p>
          </Button>
        </Box>

        <Box className={styles.filterModalBody}>
          <Box className={styles.filterBodyBox}>
            <Box className={styles.modalTopwrapper}>
              {/* Filming  Location */}
              <Box className={styles.filterBoxItem}>
                <label>
                  Filming Location{" "}
                  <img
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                    onClick={() => setLocation("")}
                  />
                </label>
                <Box className={styles.filterSelect}>
                  <Select
                    value={location}
                    onChange={handleChangeLocation}
                    MenuProps={MenuProps}
                    // inputProps={{
                    //   "aria-label": "Without label",
                    // }}
                  >
                    {countryData.map((item, index) => (
                      <MenuItem
                        key={index}
                        value={`${item.name} (${item.code})`}
                      >
                        {`${item.name} (${item.code})`}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>
              {/* Filmed On */}
              <Box className={styles.filterBoxItem}>
                <label>
                  Filmed in{" "}
                  <img
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                    onClick={() => {
                      setMonth("");
                      setYear("");
                    }}
                  />
                </label>
                <Box
                  className={`${styles.filterSelect} ${styles.filterSelectSmall}`}
                >
                  <Select
                    displayEmpty
                    value={month}
                    onChange={handleChangeMonth}
                    input={<OutlinedInput />}
                    MenuProps={MenuProps}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                  >
                    {sampleMonthsValueArray.map((item, index) => (
                      <MenuItem key={index} value={item.value}>
                        {item.month}
                      </MenuItem>
                    ))}
                  </Select>

                  <Select
                    value={year}
                    displayEmpty
                    onChange={handleChangeYear}
                    input={<OutlinedInput />}
                    MenuProps={MenuProps}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                  >
                    {sampleYearList.map((item, index) => (
                      <MenuItem key={index} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>
              {/* Unreacheble Submitter */}
              <Box className={styles.filterBoxItem}>
                <label>
                  Unreachable Submitter?{" "}
                  <img
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                    onClick={() =>
                      handleResetSingleField("unreachable_submitter")
                    }
                  />
                </label>

                <Box className={styles.filterRadio}>
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      name="unreachable_submitter"
                      value={filterParams.unreachable_submitter}
                      onChange={handleFilterParamChange}
                    >
                      <Box className={styles.filterFromControl}>
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>

              {/* For 1st modal */}

              <Box className={styles.filterFilmingBox}>
                <Box className={`${styles.filterBoxItem}`}>
                  <label>
                    Has Open Messeges?
                    <img
                      src={assest.resetIconBlue}
                      width={9}
                      height={9}
                      alt=""
                      onClick={() => handleResetSingleField("open_messages")}
                    />
                  </label>

                  <Box className={styles.filterRadio}>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        // defaultValue="female"
                        name="open_messages"
                        value={filterParams.open_messages}
                        onChange={handleFilterParamChange}
                      >
                        <Box className={styles.filterFromControl}>
                          <FormControlLabel
                            value="yes"
                            control={<Radio />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="no"
                            control={<Radio />}
                            label="No"
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Box>
                <Box className={styles.filterBoxItem}>
                  <label>
                    Show potential duplicates only?{" "}
                    <img
                      src={assest.resetIconBlue}
                      width={9}
                      height={9}
                      alt=""
                      onClick={() => handleResetSingleField("duplicate")}
                    />
                  </label>

                  <Box className={styles.filterRadio}>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="duplicate"
                        value={filterParams.duplicate}
                        onChange={handleFilterParamChange}
                      >
                        <Box className={styles.filterFromControl}>
                          <FormControlLabel
                            value="yes"
                            control={<Radio />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="no"
                            control={<Radio />}
                            label="No"
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box className={`${styles.filterBodyBox} ${styles.filterBodyBox2}`}>
              <Box className={styles.filterBoxItem}>
                <label>
                  Are There People Appearing In The Video?{" "}
                  <img
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                    onClick={() => handleResetSingleField("people_appearing")}
                  />
                </label>

                <Box className={styles.filterRadio}>
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      name="people_appearing"
                      value={filterParams.people_appearing}
                      onChange={handleFilterParamChange}
                    >
                      <Box className={styles.filterFromControl}>
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>

              <Box className={styles.filterBoxItem}>
                <label>
                  The Person Who Filmed This Video Is:{" "}
                  <img
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                    onClick={() => handleResetSingleField("person_who_filmed")}
                  />
                </label>

                <Box className={styles.filterRadio}>
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      name="person_who_filmed"
                      value={filterParams.person_who_filmed}
                      onChange={handleFilterParamChange}
                    >
                      <Box className={styles.filterFromControl}>
                        <FormControlLabel
                          value="Me"
                          control={<Radio />}
                          label="Me"
                        />
                        <FormControlLabel
                          value="A Family Member"
                          control={<Radio />}
                          label="A Family Member"
                        />
                        <FormControlLabel
                          value="A Friend"
                          control={<Radio />}
                          label="A Friend"
                        />
                        <FormControlLabel
                          value="Someone I Know"
                          control={<Radio />}
                          label="Someone I Know"
                        />
                        <FormControlLabel
                          value="A Dashcam"
                          control={<Radio />}
                          label="A Dashcam"
                        />
                        <FormControlLabel
                          value="A Security Camera"
                          control={<Radio />}
                          label="A Security Camera"
                        />
                        <FormControlLabel
                          value="Other: the kid of my friend"
                          control={<Radio />}
                          label="Other: the kid of my friend"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>

              <Box className={styles.filterBoxItem}>
                <label>
                  Did You Send/Submit/Upload This Video To A Website And/Or
                  Social Media Account?{" "}
                  <img
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                    onClick={() =>
                      handleResetSingleField("submit_other_website")
                    }
                  />
                </label>

                <Box className={styles.filterRadio}>
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      name="submit_other_website"
                      value={filterParams.submit_other_website}
                      onChange={handleFilterParamChange}
                    >
                      <Box className={styles.filterFromControl}>
                        <FormControlLabel
                          value="No, I Did Not"
                          control={<Radio />}
                          label="No, I Did Not"
                        />
                        <FormControlLabel
                          value="Yes, Another Company's Website"
                          control={<Radio />}
                          label="Yes, Another Company's Website"
                        />
                        <FormControlLabel
                          value="Yes, A Facebook Page"
                          control={<Radio />}
                          label="Yes, A Facebook Page"
                        />
                        <FormControlLabel
                          value="Yes, A Twitter Account"
                          control={<Radio />}
                          label="Yes, A Twitter Account"
                        />
                        <FormControlLabel
                          value="Yes, An Instagram Account"
                          control={<Radio />}
                          label="Yes, An Instagram Account"
                        />
                        <FormControlLabel
                          value="Yes, A YouTube Channel"
                          control={<Radio />}
                          label="Yes, A YouTube Channel"
                        />
                        <FormControlLabel
                          value="Yes, A Snaphat Account"
                          control={<Radio />}
                          label="Yes, A Snaphat Account"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>

              <Box className={styles.filterBoxItem}>
                <label>
                  Did You Sign A Licensing Agreement For This Video With Another
                  Company/Page?{" "}
                  <img
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                    onClick={() =>
                      handleResetSingleField("aggrement_with_another_company")
                    }
                  />
                </label>

                <Box className={styles.filterRadio}>
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"

                      name="aggrement_with_another_company"
                      value={filterParams.aggrement_with_another_company}
                      onChange={handleFilterParamChange}
                    >
                      <Box className={styles.filterFromControl}>
                        <FormControlLabel
                          value="No, I Did Not"
                          control={<Radio />}
                          label="No, I Did Not"
                        />
                        <FormControlLabel
                          value="Yes, I Have Filled An Online Not"
                          control={<Radio />}
                          label="Yes, I Have Filled An Online Not"
                        />
                        <FormControlLabel
                          value="Yes, I Have Signed An Exclusive Agreement"
                          control={<Radio />}
                          label="Yes, I Have Signed An Exclusive Agreement"
                        />
                        <FormControlLabel
                          value="Yes, I Have Signed A Non-Exclusive Agreement"
                          control={<Radio />}
                          label="Yes, I Have Signed A Non-Exclusive Agreement"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box className={styles.filterModalFooter}>
          <Box className={styles.buttonGroup}>
            <Button onClick={handleClose}>Cancel</Button>
            <Button
              className={styles.activeButton}
              onClick={() => {
                submitFilter();
                handleClose();
              }}
            >
              Filter now
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default MyVideosApprovedFilterModal;
